export default __webpack_public_path__ + "static/media/login.fa427140.jpg";